import { render, staticRenderFns } from "./aboneveritabanidetails.vue?vue&type=template&id=36747a76&"
import script from "./aboneveritabanidetails.vue?vue&type=script&lang=js&"
export * from "./aboneveritabanidetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports